import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { Store } from 'lucide-react';

const ALL = '__all__';

/**
 * Reusable store scope selector. Emits '' for "all stores", or a store id.
 * Radix Select cannot use an empty string as an item value, so we map the
 * "all" option to a sentinel internally.
 */
export function StoreFilter({ stores, value, onChange, allLabel = 'Toutes les boutiques', testId = 'store-filter' }) {
  return (
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
      <SelectTrigger data-testid={testId} aria-label="Filtrer par boutique" className="h-10 w-60 max-w-full rounded-md">
        <span className="flex items-center gap-2 truncate">
          <Store className="h-4 w-4 text-zinc-400 shrink-0" />
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL} data-testid={`${testId}-all`}>{allLabel}</SelectItem>
        {stores.map((s) => (
          <SelectItem key={s.id} value={s.id} data-testid={`${testId}-opt-${s.id}`}>{s.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
